import { httpClient } from '@/api/httpClient';
import {
  mapApiResourceToNotificationProviders,
  mapApiResourceToSmsProviderTestResult,
  type EmailProviderConfiguration,
  type NotificationProviders,
  type NotificationProvidersApiResource,
  type ProviderTestResult,
  type SmsProviderConfiguration,
  type SmsProviderTestResult,
  type SmsProviderTestResultApiResource,
} from './notificationProvidersApi.types';

const PROVIDERS_PATH = '/me/workspace/notification-providers';

export async function fetchNotificationProviders(): Promise<NotificationProviders> {
  const response = await httpClient.get<NotificationProvidersApiResource>(PROVIDERS_PATH);
  return mapApiResourceToNotificationProviders(response.data);
}

export async function configureEmailProvider(
  configuration: EmailProviderConfiguration
): Promise<NotificationProviders> {
  const response = await httpClient.put<NotificationProvidersApiResource>(
    PROVIDERS_PATH + '/email',
    {
      credentials: {
        host: configuration.host,
        port: configuration.port,
        username: configuration.username,
        password: configuration.password,
        use_tls: configuration.useTls,
      },
      from_name: configuration.fromName,
      from_address: configuration.fromAddress,
    }
  );
  return mapApiResourceToNotificationProviders(response.data);
}

export async function configureSmsProvider(
  configuration: SmsProviderConfiguration
): Promise<NotificationProviders> {
  const response = await httpClient.put<NotificationProvidersApiResource>(PROVIDERS_PATH + '/sms', {
    credentials: {
      account_sid: configuration.accountSid,
      api_key_sid: configuration.apiKeySid,
      api_key_secret: configuration.apiKeySecret,
    },
    from_number: configuration.fromNumber,
    messaging_service_sid: configuration.messagingServiceSid,
  });
  return mapApiResourceToNotificationProviders(response.data);
}

export async function removeEmailProvider(): Promise<NotificationProviders> {
  const response = await httpClient.delete<NotificationProvidersApiResource>(
    PROVIDERS_PATH + '/email'
  );
  return mapApiResourceToNotificationProviders(response.data);
}

export async function removeSmsProvider(): Promise<NotificationProviders> {
  const response = await httpClient.delete<NotificationProvidersApiResource>(
    PROVIDERS_PATH + '/sms'
  );
  return mapApiResourceToNotificationProviders(response.data);
}

export async function sendEmailProviderTest(recipientEmail: string): Promise<ProviderTestResult> {
  const response = await httpClient.post<ProviderTestResult>(PROVIDERS_PATH + '/email/test', {
    recipient_email: recipientEmail,
  });
  return response.data;
}

export async function sendSmsProviderTest(recipientPhone: string): Promise<SmsProviderTestResult> {
  const response = await httpClient.post<SmsProviderTestResultApiResource>(
    PROVIDERS_PATH + '/sms/test',
    { recipient_phone: recipientPhone }
  );
  return mapApiResourceToSmsProviderTestResult(response.data);
}
